import * as React from 'react';

import Trifecta from '../assets/trifecta-logo.png';

export default function TrifectaLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  return <img src={Trifecta} alt='Trifecta logo' {...props} />;
}
